import { getWithoutReviewsCount } from '@api/store.service'

const SET_COUNT = 'SET_COUNT'

export function createStore() {
  return {
    namespaced: true,
    state: {
      count: 0,
    },
    getters: {
      getCount: state => state.count,
    },
    actions: {
      async getUnrespondedCount({ commit }) {
        const { data } = (await getWithoutReviewsCount.execute())
        commit(SET_COUNT, data)
      },
    },
    mutations: {
      [SET_COUNT](state, payload) {
        state.count = payload?.count
      },
    },
  }
}
